import shortid from 'shortid';

export function saveCurrentRecipeToLocalStorage(state) {
    // We are saving just when in *single recipe* mode!
    // i.e. activeMealHash must be "1|0"
    if(state.activeMealHash !== '1|0') return;

    let unsavedRecipe = {
        'foodGroups': state.foodGroups,
        'foods': state.foods,
        'titles': state.titles,
        'descriptions': state.descriptions,
    };
    localStorage.setItem('zof_unsaved_recipe', JSON.stringify(unsavedRecipe));
}

export function handleSetRecipeTitle(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    newState.titles[action.data.mealHash] = action.data.title;
    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleAddFoodGroup(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    let mealHash = state.activeMealHash;
    if(typeof action.data.mealHash !== 'undefined') {
        mealHash = action.data.mealHash;
    }

    if (typeof newState.foodGroups[mealHash] == "undefined") {
        newState.foodGroups[mealHash] = {};
    }

    Object.keys(newState.foodGroups[mealHash]).map(g => {
        newState.foodGroups[mealHash][g].opened = false;
    });

    let groupKeys = Object.keys(newState.foodGroups[mealHash]);
    let groupsNumber = groupKeys.length;
    action.data.item_order = groupsNumber + 1;

    newState.foodGroups[mealHash][action.data.id] = action.data;

    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleSetFoodGroupTitle(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    let mealHash = state.activeMealHash;
    if(typeof action.data.mealHash !== 'undefined') {
        mealHash = action.data.mealHash;
    }
    if (typeof newState.foodGroups[mealHash] == "undefined") {
        return newState;
    }
    for (let g in newState.foodGroups[mealHash]) {
        if (newState.foodGroups[mealHash][g].id == action.data.id) {
            newState.foodGroups[mealHash][g].title = action.data.title;
        }
    }

    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleSetFoodGroupDescription(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    let mealHash;
    if(typeof action.data.mealHash === 'string') {
        mealHash = action.data.mealHash;
    } else {
        mealHash = state.activeMealHash;
    }

    if (typeof newState.foodGroups[mealHash] == "undefined") {
        return newState;
    }
    for (let g in newState.foodGroups[mealHash]) {
        if (newState.foodGroups[mealHash][g].id == action.data.id) {
            newState.foodGroups[mealHash][g].description = action.data.description;
        }
    }

    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleDeleteEmptyFoodGroups(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    let mealHash = state.activeMealHash;
    if(typeof action.data === 'object') {
        mealHash = action.data.mealHash;
    }
    let groupsToDelete = [];
    for(let g in newState.foodGroups[mealHash]) {
        let groupIsEmpty = true;
        for(let f in newState.foods[mealHash]) {
            if(newState.foods[mealHash][f].group_id == g) {
                groupIsEmpty = false;
                break;
            }
        }
        if(groupIsEmpty) groupsToDelete.push(g);
    }

    groupsToDelete.map(groupId => {
        delete newState.foodGroups[mealHash][groupId];
        if (Array.isArray(newState.foods[mealHash])) {
            newState.foods[mealHash] = newState.foods[mealHash].filter(food => food.group_id != groupId);
        }
    });

    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleChangeFoodGroupType(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    let mealHash = state.activeMealHash;
    if(typeof action.data.mealHash !== 'undefined') {
        mealHash = action.data.mealHash;
    }

    if (typeof newState.foodGroups[mealHash] == "undefined") {
        return newState;
    }
    for (let g in newState.foodGroups[mealHash]) {
        if (newState.foodGroups[mealHash][g].id == action.data.id) {
            newState.foodGroups[mealHash][g].type = action.data.type;
        }
    }

    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleOpenFoodGroup(state, action) {
    const mealHash = state.activeMealHash;
    const newState = Object.assign({}, state);
    if (typeof newState.foodGroups[mealHash] == "undefined") {
        return newState;
    }
    for (let g in newState.foodGroups[mealHash]) {
        if (newState.foodGroups[mealHash][g].id == action.data.id) {
            newState.foodGroups[mealHash][g].opened = true;
        }
    }

    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleCloseFoodGroup(state, action) {
    const mealHash = state.activeMealHash;
    const newState = Object.assign({}, state);
    if (typeof newState.foodGroups[mealHash] == "undefined") {
        return newState;
    }
    for (let g in newState.foodGroups[mealHash]) {
        if (newState.foodGroups[mealHash][g].id == action.data.id) {
            newState.foodGroups[mealHash][g].opened = false;
        }
    }

    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleMoveFoodGroup(state, action) {
    const newState = Object.assign({}, state);

    let mealHash = newState.activeMealHash;
    if(typeof action.data.mealHash !== 'undefined') {
        mealHash = action.data.mealHash;
    }

    let itemOrderSrc = newState.foodGroups[mealHash][action.data.id].item_order;
    let itemOrderDst = itemOrderSrc + action.data.direction * 1;

    const keys = Object.keys(newState.foodGroups[mealHash]);
    if(itemOrderDst < 1 || itemOrderDst > keys.length) return newState;

    let newFoodGroups = {};
    for(let g in newState.foodGroups[mealHash]) {
        let group = newState.foodGroups[mealHash][g];
        if(group.item_order == itemOrderSrc) {
            group.item_order = itemOrderDst;
            newFoodGroups[g] = group;
        } else if (group.item_order == itemOrderDst) {
            group.item_order = itemOrderSrc;
            newFoodGroups[g] = group;
        } else {
            newFoodGroups[g] = group;
        }
    }

    newState.menuChanged = true;
    newState.recipeChanged = true;
    newState.foodGroups[mealHash] = newFoodGroups;
    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleRemoveFoodGroup(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    let mealHash = state.activeMealHash;
    if(typeof action.data.mealHash !== 'undefined') {
        mealHash = action.data.mealHash;
    }

    if (typeof newState.foodGroups[mealHash] == "undefined") {
        return newState;
    }
    for (let g in newState.foodGroups[mealHash]) {
        if (newState.foodGroups[mealHash][g].id == action.data.id) {
            delete newState.foodGroups[mealHash][g];
        }
    }
    if(Array.isArray(newState.foods[mealHash])) {
        newState.foods[mealHash] = newState.foods[mealHash].filter(food => food.group_id != action.data.id);
    }

    if(typeof newState.titles[mealHash] !== 'undefined') {
        delete newState.titles[mealHash];
    }

    // Count remaining groups
    let groupsCount = 0;
    for (let g in newState.foodGroups[mealHash]) {
        groupsCount++;
    }

    // If last group remaining, make it open
    if(groupsCount == 1) {
        for (let g in newState.foodGroups[mealHash]) {
            newState.foodGroups[mealHash][g].opened = true;
        }
    }

    // If no groups left, create a new empty one
    if(groupsCount == 0) {
        let newGroupId = shortid();
        newState.foodGroups[mealHash][newGroupId] = {
            id: newGroupId,
            type: 'plate',
            title: '',
            opened: true
        };
    }

    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleModifyFoodGroupAmounts(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    let mealHash = state.activeMealHash;
    if(typeof action.data.mealHash !== 'undefined') {
        mealHash = action.data.mealHash;
    }

    let coef = action.data.coefficient;
    if (Array.isArray(newState.foods[mealHash])) {
        let foods = newState.foods[mealHash];
        foods.map(food => {
            let result = food.weight * (coef / 100.0);
            result = parseFloat((parseFloat(result).toPrecision(4)));
            if (food.group_id == action.data.group_id) {
                food.weight = result;
            }
        });
        newState.foods[mealHash] = foods;
    }
    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleMoveFoodsToGroup(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    const mealHash = state.activeMealHash;
    newState.foods[mealHash].map(food => {
        if(typeof food.group_id !== 'undefined') {
            if(food.group_id == action.data.from) {
                food.group_id = action.data.to;
            }
        } else {
            food.group_id = action.data.to;
        }
        return food;
    });
    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleAddFood(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    let mealHash;
    if(typeof action.data.mealHash === 'string') {
        mealHash = action.data.mealHash;
    } else {
        mealHash = state.activeMealHash;
    }

    if (typeof newState.foods[mealHash] == "undefined") {
        newState.foods[mealHash] = [];
    }
    newState.foods[mealHash] = [...state.foods[mealHash], action.data];
    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleRemoveFood(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    let mealHash;
    if(typeof action.data === 'object') {
        mealHash = action.data.mealHash;
        newState.foods[mealHash] = newState.foods[mealHash].filter(obj => {
            return obj.id !== action.data.id;
        });
    } else {
        mealHash = state.activeMealHash;
        newState.foods[mealHash] = newState.foods[mealHash].filter(obj => {
            return obj.id !== action.data;
        });
    }
    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleSortFood(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    let mealHash = state.activeMealHash;
    if(typeof action.data.mealHash === 'string') {
        mealHash = action.data.mealHash;
    }

    let foods = newState.foods[mealHash];

    let groupId = '';
    let index = -1;
    foods.map((food, key) => {
        if (food.id == action.data.foodId) {
            index = key;
            groupId = food.group_id;
        }
    });
    if (index < 0) return newState;

    let indexNew = index + action.data.direction;
    let minKey = 999999, maxKey = -1;
    let destKey = -1, destKeyDist = 999999;

    foods.map((food, key) => {
        if (food.group_id === groupId) {
            if (key > maxKey) maxKey = key;
            if (key < minKey) minKey = key;

            if(action.data.direction > 0) {
                const dist = key - index;
                if(dist > 0 && dist < destKeyDist) {
                    destKeyDist = dist;
                    destKey = key;
                }
            } else {
                const dist = index - key;
                if(dist > 0 && dist < destKeyDist) {
                    destKeyDist = dist;
                    destKey = key;
                }
            }
        }
    });

    if (indexNew < minKey || indexNew > maxKey) return newState;
    if(destKey < 0) return newState;

    let tmp = foods[index];
    foods[index] = foods[destKey];
    foods[destKey] = tmp;
    newState.foods[mealHash] = foods;
    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleMoveFoodToPlate(state, action) {
    const newState = Object.assign({}, state);

    const sourceMealHash = action.data.sourceMealHash || action.data.mealHash || state.activeMealHash;
    const targetMealHash = action.data.mealHash || state.activeMealHash;

    if (sourceMealHash === targetMealHash) {
        let foods = [...newState.foods[sourceMealHash]];
        foods = foods.map(food => food.id == action.data.foodId ? { ...food, group_id: action.data.foodGroupId } : food);
        newState.foods = { ...newState.foods, [sourceMealHash]: foods };
    } else {
        let sourceFoods = [...newState.foods[sourceMealHash]];
        const food = sourceFoods.find(f => f.id == action.data.foodId);
        if (food) {
            sourceFoods = sourceFoods.filter(f => f.id != action.data.foodId);
            const targetFoods = [...(newState.foods[targetMealHash] || []), { ...food, group_id: action.data.foodGroupId }];
            newState.foods = { ...newState.foods, [sourceMealHash]: sourceFoods, [targetMealHash]: targetFoods };
        }
    }

    newState.menuChanged = true;
    newState.recipeChanged = true;
    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleSetFoodAmount(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    let foods = newState.foods[action.data.mealHash];
    foods.map((food) => {
        if (food.id == action.data.foodId) {
            food.weight = action.data.weight;
        }
    });
    newState.foods[action.data.mealHash] = foods;
    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleSetFoodAsDrink(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    let foods = newState.foods[action.data.mealHash];
    foods.map((food) => {
        if (food.id == action.data.foodId) {
            food.is_drink = action.data.is_drink;
        }
    });
    newState.foods[action.data.mealHash] = foods;
    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleAddFoodModification(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    action.data.modificationId = 1 * action.data.modificationId;
    const foodId = action.data.foodId;
    if (typeof newState.modifications[foodId] === 'undefined') {
        newState.modifications[foodId] = [];
    }
    let count = newState.modifications[foodId].length;
    if (count < 999) {
        newState.modifications[foodId] = newState.modifications[foodId].filter(e => e !== action.data.modificationId);
        newState.modifications[foodId] = [...newState.modifications[foodId], action.data.modificationId];
    }
    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}

export function handleRemoveFoodModification(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    action.data.modificationId = 1 * action.data.modificationId;
    let modificationsArray = [action.data.modificationId];
    let resultFoodId = action.data.foodId;
    for (let foodId in newState.modifications) {
        if (foodId = action.data.foodId) {
            resultFoodId = foodId;
            modificationsArray = newState.modifications[foodId];
        }
    }
    modificationsArray = modificationsArray.filter(e => e !== action.data.modificationId);
    newState.modifications[resultFoodId] = modificationsArray;
    saveCurrentRecipeToLocalStorage(newState);
    return newState;
}
